import { render, staticRenderFns } from "./VdoSetList.vue?vue&type=template&id=3492892b&scoped=true&"
import script from "./VdoSetList.vue?vue&type=script&lang=js&"
export * from "./VdoSetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492892b",
  null
  
)

export default component.exports